export default "<h3>November 21, 2018</h3>\r\n<p>Update 0.51 fixes some bugs.</p>";